import './global.css';

import React from 'react';
import { Platform, StatusBar } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { GuestPromptModalHost } from './src/components/GuestPromptModalHost';
import { AuthProvider } from './src/contexts/AuthContext';
import { ThemeProvider, useAppTheme } from './src/contexts/ThemeContext';
import { RootNavigator } from './src/navigation/RootNavigator';
import { PrivacyPolicyWebPage } from './src/screens/web/PrivacyPolicyWebPage';
import { TermsOfServiceWebPage } from './src/screens/web/TermsOfServiceWebPage';

function normalizedWebPath(): string {
  if (Platform.OS !== 'web' || typeof window === 'undefined') {
    return '';
  }
  return window.location.pathname.replace(/\/+$/, '') || '/';
}

function isWebPrivacyPolicyPath(): boolean {
  if (Platform.OS !== 'web') {
    return false;
  }
  return normalizedWebPath() === '/privacy-policy';
}

function isWebTermsPath(): boolean {
  if (Platform.OS !== 'web') {
    return false;
  }
  return normalizedWebPath() === '/terms-of-service';
}

function ThemedChrome({ children }: { children: React.ReactNode }) {
  const { isDark } = useAppTheme();
  return (
    <>
      <StatusBar barStyle={isDark ? 'light-content' : 'dark-content'} />
      {children}
    </>
  );
}

function App() {
  if (isWebPrivacyPolicyPath()) {
    return (
      <GestureHandlerRootView style={{ flex: 1 }}>
        <PrivacyPolicyWebPage />
      </GestureHandlerRootView>
    );
  }

  if (isWebTermsPath()) {
    return (
      <GestureHandlerRootView style={{ flex: 1 }}>
        <TermsOfServiceWebPage />
      </GestureHandlerRootView>
    );
  }

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <SafeAreaProvider>
        <ThemeProvider>
          <ThemedChrome>
            <AuthProvider>
              <GuestPromptModalHost />
              <RootNavigator />
            </AuthProvider>
          </ThemedChrome>
        </ThemeProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}

export default App;
